import { Delete, Edit } from "@mui/icons-material";
import {
    Accordion,
    AccordionDetails,
    AccordionSummary,
    IconButton,
} from "@mui/material";
import classnames from "classnames";
import { useContext, useState } from "react";
import ConfirmationDialog from "../../../components/ConfirmationDialog";
import { isRoleAdmin } from "../../../frappeConfig";
import arrowIcon from "../../../images/ri_arrow-up-s-line.svg";
import OrderStatusIcon from "./OrderStatusIcon";
import { useStyles } from "./styles";
import { AppContext } from "../../../AppContext";

const OrderCartItem = ({
    item,
    onItemEdit,
    onDelete,
    isSaved,
    itemDeleting,
    isHighlighted,
}) => {
    const classes = useStyles();

    const [expanded, setExpanded] = useState(false);

    const { userInfo, elevatedPrivileges } = useContext(AppContext);

    const [selectedOrder, setSelectedOrder] = useState(null);

    const [deleteConfirmOpen, setDeleteConfirmOpen] = useState(false);
    const [deleteConfirmTitle, setDeleteConfirmTitle] = useState("");
    const [itemToDelete, setItemToDelete] = useState(null);

    const handleDeleteOrderItemRequest = (item) => {
        if (isSaved) {
            setDeleteConfirmTitle(
                `Deleting ${item.qty} * ${item.item.item_code}`
            );
            setItemToDelete({
                ...item,
                elevatedPrivileges: elevatedPrivileges,
            });
            setDeleteConfirmOpen(true);
        } else {
            onDelete(item);
        }
    };

    const handleDeleteConfirm = (password, qty, note, waste) => {
        onDelete(itemToDelete, password, qty, note, waste);
        setTimeout(() => {
            setDeleteConfirmOpen(false);
        }, 1000);
    };

    const handleDeleteConfirmClose = () => {
        setItemToDelete(null);
        setDeleteConfirmOpen(false);
    };

    const handleOrderItemEdit = (item) => {
        onItemEdit?.(item);
    };

    const getOnChange = () => {
        if (item.addons.length > 0) {
            setExpanded(!expanded);
        } else {
            setExpanded(false);
        }
    };

    const getIcon = () => {
        let classesName = classes.Arrow_disabled;
        if (item.addons && item.addons.length > 0) {
            classesName = classes.Arrow_enabled;
        }
        return (
            <div className={classesName}>
                <div>
                    <img src={arrowIcon} />
                </div>
            </div>
        );
    };

    const checkCanDelete = (item) => {
        return (
            onDelete &&
            (item.item.status === "Attending" ||
                isRoleAdmin(userInfo.role_profile_name))
        );
    };

    const checkCanEdit = (item) => {
        return onItemEdit && item.item.status === "Attending";
    };

    const getTotalPrice = (item) => {
        let addonsTotal = 0;
        let total = 0;

        total += item.qty * (item.item.rate || item.item.standard_rate);

        if (item.addons) {
            item.addons.map((addon) => {
                addonsTotal += addon?.standard_rate * item.qty;
            });
        }

        addonsTotal = addonsTotal || 0;

        return total + addonsTotal;
    };

    return (
        <>
            <Accordion
                expanded={expanded}
                // onChange={getOnChange}
                className={classes.Accordion}
            >
                <AccordionSummary
                    aria-controls={
                        item.item.identifier || item.entry_name + "-content"
                    }
                    id={item.item.identifier || item.entry_name + "-header"}
                    expandIcon={getIcon()}
                    className={classes.AccordionSummary}
                >
                    <div
                        className={classnames("Item", {
                            IsSelected: item?.item?.item_code == selectedOrder,
                            "Item--highlight": isHighlighted,
                        })}
                        onClick={() => setSelectedOrder(item)}
                    >
                        <div className="Item__Main">
                            <div className="Content" onClick={getOnChange}>
                                <div className="Img">
                                    <div
                                        className="Img"
                                        style={{
                                            width: "50px",
                                            height: "50px",
                                        }}
                                    >
                                        {item && item?.item?.item_code && (
                                            <img
                                                src={item?.item?.cover}
                                                alt="Image"
                                                style={{
                                                    width: "100%",
                                                    height: "100%",
                                                }}
                                            />
                                        )}{" "}
                                    </div>
                                </div>
                                <div className="Name">
                                    <div>{item.item.item_name}</div>
                                    <div>x {item.qty}</div>
                                </div>
                                <div className="Price">
                                    NIS {getTotalPrice(item)}
                                </div>
                            </div>
                            <div className="Item_2">
                                <div className="Item__Secondary">
                                    <div className="PostActions">
                                        <div className="ItemDetails">
                                            <OrderStatusIcon
                                                status={item.item.status}
                                            />
                                        </div>
                                        {checkCanDelete(item) && (
                                            <IconButton
                                                onClick={(event) => {
                                                    event.stopPropagation();
                                                    handleDeleteOrderItemRequest(
                                                        item
                                                    );
                                                }}
                                            >
                                                <Delete
                                                    fontSize="small"
                                                    className={
                                                        isSaved
                                                            ? classes.Table_edit_order_right_saved
                                                            : classes.Table_edit_order_right
                                                    }
                                                />
                                            </IconButton>
                                        )}
                                        {checkCanEdit(item) && (
                                            <IconButton
                                                onClick={() =>
                                                    handleOrderItemEdit(item)
                                                }
                                            >
                                                <Edit
                                                    className={
                                                        isSaved
                                                            ? classes.Table_edit_order_right_saved
                                                            : classes.Table_edit_order_right
                                                    }
                                                />
                                            </IconButton>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </AccordionSummary>

                <AccordionDetails style={{ padding: 0 }}>
                    <div className="Item">
                        <div className="Item__Secondary">
                            {item.addons &&
                                item?.addons?.map((i, index) => {
                                    return (
                                        <div
                                            key={
                                                "ItemAddons_" +
                                                item.item.name +
                                                "_" +
                                                i?.item_code
                                            }
                                        >
                                            <span>- {i?.item_code}</span>
                                            <span>+ {i?.standard_rate}</span>
                                        </div>
                                    );
                                })}
                        </div>
                    </div>
                </AccordionDetails>
            </Accordion>
            <ConfirmationDialog
                open={deleteConfirmOpen}
                onClose={handleDeleteConfirmClose}
                onConfirm={handleDeleteConfirm}
                item={itemToDelete}
                title={deleteConfirmTitle}
                loading={itemDeleting}
                addQtyField={item.qty}
                showWasteToggle={true}
            />
        </>
    );
};

export default OrderCartItem;
